import { render } from "./RecruitFunds.vue?vue&type=template&id=15971de4&scoped=true"
import script from "./RecruitFunds.vue?vue&type=script&lang=js"
export * from "./RecruitFunds.vue?vue&type=script&lang=js"

import "./RecruitFunds.vue?vue&type=style&index=0&id=15971de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15971de4"]])

export default __exports__